module.exports = __webpack_public_path__ + "static/media/autoCADAddons2.13617e5a.png";